import { isNumber } from "lodash";
import styled from "styled-components";

type InputStyleProps = { height?: number; borderRadius?: number };
type CustomAbsoluteBoxProps = {
  top?: number | string;
  right?: number | string;
  bottom?: number | string;
  left?: number | string;
};

export const CustomInputFieldStyles = styled.div<{ inputStyles?: InputStyleProps }>`
  .textfield-component-wrapper > input {
    box-shadow: none;
    background: #1d1f23;
    border: 2px solid #242425;
    height: ${({ inputStyles }) => (inputStyles?.height ? `${inputStyles.height}px` : "34px")};
    border-radius: ${({ inputStyles }) => (inputStyles?.borderRadius ? `${inputStyles.borderRadius}px` : 0)};
    padding: 12px;
  }
`;

export const TabContentWrapper = styled(CustomInputFieldStyles)<{ maxWidth?: number }>`
  flex: 1;
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
  max-width: ${({ maxWidth }) => (maxWidth ? `${maxWidth}px` : "100%")};
`;

export const CustomAbsoluteBox = styled.p<CustomAbsoluteBoxProps>`
  position: absolute;
  top: ${({ top = "unset" }) => (isNumber(top) ? `${top}px` : top)};
  right: ${({ right = "unset" }) => (isNumber(right) ? `${right}px` : right)};
  bottom: ${({ bottom = "unset" }) => (isNumber(bottom) ? `${bottom}px` : bottom)};
  left: ${({ left = "unset" }) => (isNumber(left) ? `${left}px` : left)};
`;

export const ImageTag = styled(CustomAbsoluteBox)<{ title?: string }>`
  background: ${({ theme, title }) => {
    const text = title?.toLowerCase();
    if (text === "photo" || text === "v2") {
      return theme.blueDark;
    }
    if (text === "video" || text === "v1") {
      return theme.deepGreenTeal;
    }
    if (text === "v3") {
      return theme.fieryOrange;
    }
    return theme.blueDark;
  }};
  color: ${({ theme }) => theme.white};
  font-size: 11px;
  font-weight: 400;
  width: 49px;
  height: 17px;
  border-radius: 99px;
  font-size: 11px;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1;
`;
